export default {"src":"/_next/static/media/display-chart-up-classic-solid.869318b6.svg","height":24,"width":24};